import React, { useEffect, useRef } from "react";
import "summernote/dist/summernote-lite.css";
import "summernote/dist/summernote-lite.js";
import $ from "jquery";

const SummernoteEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    // Initialisation de Summernote
    $(editorRef.current).addClass('editor-Answer').summernote({
      height: 300,
      lang: "fr-FR",
      inheritPlaceholder: true,
      dialogsInBody: true,
      toolbar: [
        ["style", ["bold", "italic", "underline", "clear"]],
        ["font", ["strikethrough", "superscript", "subscript"]],
        ["para", ["ul", "ol", "paragraph"]],
        ["table", ["table"]],
        ["insert", ["link", "picture", "video"]],
        ["view", ["fullscreen", "codeview"]],
      ],
      callbacks: {
        onBlur: function () {
          const contents = $(editorRef.current).summernote("code");
          onChange(contents);
        },
        onImageUpload: function (files) {
          const file = files[0];
          const reader = new FileReader();
          reader.onloadend = function () {
            const image = $('<img>').attr('src', reader.result);
            $(editorRef.current).summernote('insertNode', image[0]);
          };
          reader.readAsDataURL(file);
        }
      }
    });
  
    // Forcer la direction LTR
    $(editorRef.current).css("direction", "ltr");
  
    // Corriger le bug du body grisé quand un modal se ferme
    $(document).on("hidden.bs.modal", ".modal", function () {
      if ($(".modal:visible").length) {
        $("body").addClass("modal-open");
      }
    });
  
    return () => {
      $(editorRef.current).summernote("destroy");
      $(document).off("hidden.bs.modal"); // Nettoyage
    };
  }, []);
  

  // Mise à jour de l'éditeur si la valeur change depuis l'extérieur
  useEffect(() => {
    if (editorRef.current) {
      $(editorRef.current).summernote("code", value);
    }
  }, [value]);

  return <div ref={editorRef} />;
};

export default SummernoteEditor;
